import React from "react";
import { Box, Typography } from "@mui/material";
import { KPICarousel, KPICard } from "../../../Components/KPICarousel";

// ─── Temporary KPI data (replace with API call when backend is ready) ─────────
const kpiData = [
  {
    title: "Avg Range per Vehicle",
    titleTooltip: "Average distance a vehicle can travel on a full charge during the selected period.",
    value: "142 km",
    previousValue: "138 km",
    trend: "up",
    isPositive: true,
    trendValue: "2.9%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Max Range Recorded", value: "198 km" },
      { label: "Min Range Recorded", value: "87 km" },
    ],
  },
  {
    title: "Avg Distance per Vehicle",
    titleTooltip: "Average distance covered per vehicle during the selected period.",
    value: "48 km",
    previousValue: "45 km",
    trend: "up",
    isPositive: true,
    trendValue: "6.7%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Total Fleet Distance", value: "23,376 km" },
      { label: "Vehicles Reporting", value: "487" },
    ],
  },
  {
    title: "Energy Consumption per km",
    titleTooltip: "Average energy consumed per kilometre across the fleet.",
    value: "0.82 kWh",
    previousValue: "0.79 kWh",
    trend: "up",
    isPositive: false,
    trendValue: "3.8%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Total Energy Consumed", value: "3,240 kWh" },
      { label: "Fleet Avg SoC at Start", value: "91 %" },
    ],
  },
  {
    title: "Range Degradation Rate",
    titleTooltip: "Average reduction in maximum range compared to the vehicle's rated range.",
    value: "8.4 %",
    previousValue: "8.1 %",
    trend: "up",
    isPositive: false,
    trendValue: "0.3%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Vehicles with High Degrad.", value: "34" },
      { label: "Fleet Rated Range", value: "155 km" },
    ],
  },
  {
    title: "Low Range Alerts",
    titleTooltip: "Number of vehicles that reported critically low range during the selected period.",
    value: "12",
    previousValue: "18",
    trend: "down",
    isPositive: true,
    trendValue: "33.3%",
    trendPeriod: "vs. Last 30 Days",
    metrics: [
      { label: "Threshold", value: "< 30 km" },
      { label: "Vehicles Affected", value: "12" },
    ],
  },
];

// ─── Component ─────────────────────────────────────────────────────────────────
const RangeKPISection = ({ vehiclesConnected, showHeader = true }) => {
  const renderKPICard = (kpi) => (
    <KPICard
      title={kpi.title}
      titleTooltip={kpi.titleTooltip}
      value={kpi.value}
      previousValue={kpi.previousValue}
      trend={kpi.trend}
      isPositive={kpi.isPositive}
      trendValue={kpi.trendValue}
      trendPeriod={kpi.trendPeriod}
      metrics={kpi.metrics}
      totalVehicles={vehiclesConnected}
    />
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {showHeader && (
        <Box>
          <Typography
            variant="fw400s20c000"
            sx={{ lineHeight: "28px", fontWeight: 300 }}
          >
            Key Performance Indicators
          </Typography>
        </Box>
      )}
      <KPICarousel
        data={kpiData}
        renderCard={renderKPICard}
      />
    </Box>
  );
};

export default RangeKPISection;
